import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Button } from 'app-core';

import ButtonType = Data.Core.ButtonType;
import IconType = Data.Core.IconType;

@Component({
  selector: 'app-dummy-data-home',
  templateUrl: './dummy-data-home.component.html',
  styleUrls: ['./dummy-data-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DummyDataHomeComponent {
  public doctorsButton: Button = new Button({
    label: 'Doctors',
    type: ButtonType.flatButton,
    icon: IconType.doctorsIcon,
    action: () => {
      this._router.navigate(['manage/dummy-data/doctors/users'], {
        queryParamsHandling: 'preserve',
      });
    },
  });

  public bodyScanButton: Button = new Button({
    label: 'Body Scan',
    type: ButtonType.flatButton,
    icon: IconType.radiologistIcon,
    action: () => {
      this._router.navigate(['manage/dummy-data/scan/users'], {
        queryParamsHandling: 'preserve',
      });
    },
  });

  public constructor(private readonly _router: Router) {}
}
